import { RouteUrls } from '@lentau/ui-kit/core/enums/route.enum';

function getPathname(url: string): string {
  if (!url) {
    return '';
  }

  if (/^https?:\/\//i.test(url)) {
    try {
      return new URL(url).pathname;
    } catch {
      return '';
    }
  }

  const withoutHash: string = url.split('#')[0] ?? '';
  return withoutHash.split('?')[0] ?? '';
}

function pathStartsWithRouteSegment(pathname: string, segment: string): boolean {
  const normalized: string = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const prefix: string = `/${segment}/`;

  return normalized === `/${segment}` || normalized.startsWith(prefix);
}

/** Utkonos: не применять SEM-редирект /item/:id/ → /product/slug-id/ (роута /product/ нет). */
export function shouldIgnoreItemToProductRedirect(
  sourceUrl: string,
  targetUrl: string | null | undefined,
  isUtkonos: boolean
): boolean {
  if (!isUtkonos || !targetUrl) {
    return false;
  }

  const sourcePath: string = getPathname(sourceUrl);
  const targetPath: string = getPathname(targetUrl);

  return (
    pathStartsWithRouteSegment(sourcePath, RouteUrls.Item) &&
    pathStartsWithRouteSegment(targetPath, RouteUrls.Product)
  );
}
